/* ============================================================
   Manuals Only Club — moc-theme.js (deferred)
   Scroll-reveal via IntersectionObserver, honoring
   prefers-reduced-motion. FAQ uses native <details>/<summary>
   (ARIA-correct with no JS), so no accordion script needed.
   ============================================================ */
(function () {
  'use strict';

  // mark that JS is available (CSS fallback shows content if not)
  document.documentElement.classList.remove('no-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = document.querySelectorAll('.moc-reveal');
  if (!nodes.length) return;

  if (reduce || !('IntersectionObserver' in window)) {
    nodes.forEach(function (n) { n.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  nodes.forEach(function (n) { io.observe(n); });

  /* ---- countdowns ([data-moc-countdown]) ---- */
  var timers = document.querySelectorAll('[data-moc-countdown]');
  if (timers.length) {
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tick = function () {
      var now = Date.now();
      timers.forEach(function (el) {
        var t = new Date(el.getAttribute('data-target')).getTime();
        if (isNaN(t)) return;
        var diff = t - now;
        if (diff <= 0) {
          if (!el.dataset.done) {
            el.dataset.done = '1';
            el.innerHTML = '<p class="moc-countdown__expired">' + (el.getAttribute('data-expired') || '') + '</p>';
          }
          return;
        }
        var set = function (sel, v) { var n = el.querySelector(sel); if (n) n.textContent = v; };
        set('[data-d]', Math.floor(diff / 86400000));
        set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
        set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
        set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
      });
    };
    tick();
    setInterval(tick, 1000);
  }
})();
